import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function TopNavigation({ active = "Voucher" }) {
  const navigate = useNavigate();
  const buttons = [
    { label: "Ledgers", variant: "outline-secondary", path: "/ledger" },
    { label: "Stock Items", variant: "outline-primary", path: "/stock-items" },
    { label: "Vouchers", variant: "outline-warning", path: "/voucher" },
    { label: "Orders", variant: "outline-success", path: "/order" },
  ];

  return (
    <div className="d-flex flex-wrap gap-2 m-3">
      {buttons.map((btn) => {
        const isActive = btn.label === active;
        const activeVariant = btn.variant.replace("outline-", "");
        return (
          <Button
            size="sm"
            key={btn.label}
            variant={isActive ? activeVariant : btn.variant}
            className={isActive ? "fw-bold shadow-sm px-4" : "px-4"}
            onClick={() => navigate(btn.path)}
          >
            {btn.label}
          </Button>
        );
      })}
    </div>
  );
}
